import * as React from 'react';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/filters/attributes/dataGrid';
import { attributesGridColumns } from '@process-advisor/process-miner/filters/attributes/attributesGridColumns';
import { Event } from '@process-advisor/process-miner/api/events';

type Props = {
    attribute: string;
    attributeType: string;
    setApplyEnabled: (value: boolean) => void;
};

export const AttributesGrid: React.FC<Props> = ({
    attribute,
    attributeType,
    setApplyEnabled,
}) => {
    const [data, setData] = React.useState([]);

    React.useEffect(() => {
        
        const processAttributesTableData
            = apiProvider.processAttributesTable({ attribute, attributeType });
        setData(processAttributesTableData);
    }, [attribute, attributeType]);

    React.useEffect(() => {
        const listener = () => {
            setData(apiProvider.processAttributesTable({ attribute, attributeType }));
        };

        apiProvider.on(Event.updateFilterAttributes, listener);
        return () => {
            apiProvider.off(Event.updateFilterAttributes, listener);
        };
    }, [attribute, attributeType]);

    return (
        <DataGrid
            height="300px"
            rows={data}
            setApplyEnabled={setApplyEnabled}
            attributeType={attributeType}
            columns={attributesGridColumns()} />
    );
};
